import { Smartphone } from "lucide-react";
import { OTHERS_LABEL } from "@/lib/deviceCatalog";

function formatDeviceLabel(d) {
  const plat = d.platform === OTHERS_LABEL ? (d.platform_custom || d.platform) : d.platform;
  const ver = d.release_version === OTHERS_LABEL ? (d.release_version_custom || d.release_version) : d.release_version;
  return `${d.model || "Unknown model"} — ${plat || ""} ${ver || ""}`.trim();
}

/**
 * Read-only display of a tester's structured device inventory.
 * Used on the tester's Profile page (view mode) and on the admin UserDetail page.
 */
export default function DeviceInventoryList({ value = [], emptyText = "No devices added yet.", testid = "device-inventory-list" }) {
  if (!Array.isArray(value) || value.length === 0) {
    return (
      <div className="text-sm text-slate-500 italic" data-testid={`${testid}-empty`}>{emptyText}</div>
    );
  }
  return (
    <div className="border border-slate-200 rounded-md divide-y divide-slate-200 bg-white" data-testid={testid}>
      {value.map((d, i) => (
        <div key={i} className="flex items-center gap-3 px-3 py-2.5" data-testid={`${testid}-row-${i}`}>
          <div className="w-8 h-8 rounded-md bg-slate-100 text-slate-500 flex items-center justify-center shrink-0">
            <Smartphone className="w-4 h-4" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-slate-900 truncate">{formatDeviceLabel(d)}</div>
            <div className="text-xs text-slate-500 truncate">
              {[d.category, d.manufacturer].filter(Boolean).join(" · ")}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
